import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

Unit.propTypes = {
    unit: PropTypes.string.isRequired,
    noSpace: PropTypes.bool,
};

export const resolveUnit = (unit, t) => t(`unit.${unit.toLowerCase()}`);

function Unit(props) {
    const {
        unit,
        noSpace = false,
    } = props;
    const { t } = useTranslation();
    return (
        <>
            {noSpace ? '' : <>&nbsp;</>}{resolveUnit(unit, t)}
        </>
    );
}

export default Unit;
